import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorImgLight from './assets/errorLight.svg';
import ErrorImgDark from './assets/errorDark.svg';
import { logger } from 'RootShared/utility/ErrorLogger';

import Button from '../Button/Button';

const ErrorFallback = ({ error }) => {
  process.env.NODE_ENV !== 'development' && logger.fatal(error);
  return (
    <div className="error-bundle-page">
      <div className="error-bundle-page__img">
        <img
          className="error-bundle-page__img-item"
          src={JSON.parse(localStorage.getItem('nightMode')) ? ErrorImgDark : ErrorImgLight}
          alt="error page"
        />
      </div>
      <div className="error-bundle-page__content">
        <h2 className="error-bundle-page__content-process">Something went wrong</h2>
      </div>
      <Button text="Try again" variant="primary" onClick={() => window.location.reload()} />
    </div>
  );
};

const withErrorBoundary = (ComponentThatMayError) => (props) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ComponentThatMayError {...props}/>
    </ErrorBoundary>
  );
};

export default withErrorBoundary;
